<template>
  <section class="subscribers-list">
    <GateDisconnectConfirm
      v-if="disconnectConfirmOpened"
      :loading="$store.getters.isLoading"
      :address-name="currentGate?.property?.address"
      @close="onDisconnectConfirmClose"
      @approve="onDisconnectConfirmApprove"
    />
    <!-- <Popup
      v-if="filePopup.opened"
      title="Добавить абонентов через файл"
      @close="onFilePopupClose"
      @approve="onFilePopupApprove"
    >
      <p>
        Выгрузить из BasIP файлы с абонентами и загрузите сюда (справка по
        формату файла).
      </p>
      <FormFile v-model="filePopup.file" label="Загрузить файл с абонентами" />
    </Popup> -->

    <Popup
      v-if="clientPopup.opened"
      title="Редактировать доступы"
      @close="onClientPopupClose"
      @approve="onClientPopupApprove"
      :minBodyHeight="clientPopup.minBodyHeight"
    >
      <Select
        v-model="clientPopup.value"
        :mode="clientPopup.mode"
        :options="clientPopup.options"
        :placeholder="clientPopup.placeholder"
        :multipleLabel="clientPopup.multipleLabel"
        :closeOnSelect="false"
        @open="onSelectOpen"
        @close="onSelectClose"
      />
      <small style="color: red; font-size: 12px" v-if="clientPopup.error">
        Следующие доступы не могут назначаться вместе с другими:
        <b>{{ clientPopup.restrictedRules.join(',') }}</b>
      </small>
    </Popup>

    <div class="subscribers-list__filters">
      <Filters v-model="filtersActive" :filters="filters" />
    </div>
    <div class="subscribers-list__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :rows="tableRows"
        @switcherClick="onSwitcherClick"
        @rowClick="onRowClick"
      />
      <Pagination
        v-model="currentPage"
        v-bind="pagination"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="subscribers-list__actions">
      <Actions
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Popup from '../../components/Popup.vue'
import Select from '../../components/Form/Select.vue'
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import Pagination from '../../components/Pagination.vue'
import MockGateAddress from '../../mixins/Mock/MockGateAddress.js'
import MockPagination from '../../mixins/Mock/MockPagination.js'
import GateDisconnectConfirm from '../Popup/GateDisconnectConfirm.vue'

export default {
  name: 'SubscribersList',
  mixins: [MockGateAddress, MockPagination],
  components: {
    Popup,
    Filters,
    Table,
    Actions,
    Pagination,
    Select,
    GateDisconnectConfirm,
  },
  data() {
    return {
      filtersActive: {},
      rowsSelected: [],
    }
  },
  watch: {
    filtersActive: {
      handler(value) {
        this.filterContacts({
          ...value,
          status: value.status ?? '',
        })
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.subscribers-list {
  &__filters {
    margin: 0px $space-md $space-lg;
  }

  &__list {
    margin: 0px $space-md $space-lg;
  }
}
</style>
